import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback, useMemo } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import TextInput from 'src/components/TextInput';
import PopUp from 'src/components/design-system/PopUp';
import { CanManageOfflineSuppliers } from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';
import { getBgColor, getIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const ApId = () => {
  const canManageOfflineSuppliers = usePermission({ permissions: CanManageOfflineSuppliers });
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const handleInputChange = useContextSelector(InvoiceContext, (value) => value.handleInputChange);
  const errors = useContextSelector(InvoiceContext, (value) => value.errors);
  const setApIdDirty = useContextSelector(InvoiceContext, (value) => value.setApIdDirty);
  const warnings = useContextSelector(InvoiceContext, (value) => value.warnings);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const getLinkIcon = useContextSelector(InvoiceContext, (value) => value.getLinkIcon);
  const ApIdandExternalSupplierNametooltipMsg = useContextSelector(
    InvoiceContext,
    (value) => value.ApIdandExternalSupplierNametooltipMsg
  );

  const hasWarning = useMemo(() => !!warnings.apId.length, [warnings.apId.length]);
  const hasError = useMemo(() => !!errors.apId.length, [errors.apId.length]);

  const handleApIdChange = useCallback(
    (e: TextBoxChangeEvent) => {
      setApIdDirty();
      handleInputChange('apId')(e);
    },
    [handleInputChange, setApIdDirty]
  );

  const title = useMemo(
    () => (invoice?.apId === null ? '' : invoice?.apId === '' ? '' : invoice?.apId),
    [invoice?.apId]
  );

  return (
    <PopUp
      content={
        <div className="flex flex-col gap-2">
          <PopUpContentWrapper type="Warning" contents={warnings.apId} />
          <PopUpContentWrapper type="Error" contents={errors.apId} />
        </div>
      }
      show={hasError || hasWarning}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'right', vertical: 'top' }}
    >
      <div
        className={`p-1 ${getBgColor(errors.apId, warnings.apId)} text-[13px]`}
        title={!hasError && !hasWarning ? invoice?.apId : ''}
      >
        <p className="font-bold flex items-center pb-1">
          AP ID #<span title={ApIdandExternalSupplierNametooltipMsg}>{getLinkIcon()}</span>
          <span className="px-2">{getIcon(errors.apId, warnings.apId)}</span>
        </p>
        {isInvoiceEditDisabled || !canManageOfflineSuppliers ? (
          <p>{invoice?.apId}</p>
        ) : (
          <TextInput title={title} value={title} onChange={handleApIdChange} valid={!hasError} />
        )}
      </div>
    </PopUp>
  );
};

export default ApId;
